import { EditorPlugin, PluginEvent, PluginEventType } from 'roosterjs-editor-types';
import { chainSanitizerCallback } from 'roosterjs-editor-dom';

const CtsWorkaroundPlugin: EditorPlugin = {
    getName: () => 'CtsWorkaround',
    initialize: () => {},
    dispose: () => {},
    onPluginEvent,
};

const WHITE_SPACE_CSS_NAME = 'white-space';

export default CtsWorkaroundPlugin;

// Workaround a CTS issue. CTS will always add line-breaks between DIVs.
// But if there is style white-space:pre around, this behavior will cause extra line-breaks.
// We already replaced spaces to "&nbsp;" from HtmlSanitizer, so we can remove white-space:pre here.
function onPluginEvent(e: PluginEvent) {
    if (e.eventType == PluginEventType.BeforePaste) {
        chainSanitizerCallback(
            e.sanitizingOption.cssStyleCallbacks,
            WHITE_SPACE_CSS_NAME,
            (value, element, thisStyle) => {
                // Still set the value to thisStyle so that it can still take effect (replace spaces to &nbsp;)
                // But return false to remove it from HTML to avoid CTS adding extra empty lines
                thisStyle[WHITE_SPACE_CSS_NAME] = value;
                return value != 'pre';
            }
        );
    }
}
